<app-page-header
    title="Gestión de Menús"
    mobileTitle="Menús"
    icon="fas fa-bars">
    @if (appSettings.isMobile() && perm.canCurrent('canCreate') && !isDirty()) {
        <button headerExtra type="button" class="btn btn-success btn-xs" (click)="createNewMenu()">
            <i class="fas fa-plus me-1"></i>Nuevo
        </button>
    }
</app-page-header>

@if (appSettings.isMobile() && isDirty() && perm.canCurrent('canUpdate')) {
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm" (click)="saveChanges()">
        Guardar
    </button>
</app-mobile-footer>
}

<div class="row">
    <div class="col-12">
        <div [class.panel]="!appSettings.isMobile()" [class.p-4]="!appSettings.isMobile()"
             [class.mobile-requests-container]="appSettings.isMobile()">
            <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <div>
                    <p class="text-muted small mb-0">
                        @if (appSettings.isMobile()) {
                            Mantén presionado para reordenar. Usa las flechas para cambiar jerarquía.
                        } @else {
                            Arrastra para reordenar. Usa las flechas para cambiar jerarquía.
                        }
                    </p>
                </div>
                @if (!appSettings.isMobile()) {
                <div>
                    @if (perm.canCurrent('canCreate')) {
                    <button class="btn btn-success ms-2" (click)="createNewMenu()">
                        <i class="fas fa-plus me-1"></i> Nuevo Menú
                    </button>
                    }
                    @if(isDirty() && perm.canCurrent('canUpdate')){
                    <button class="btn btn-primary shadow-sm ms-2" (click)="saveChanges()">
                        <i class="fas fa-save me-2"></i> Guardar
                    </button>
                    }
                    <button class="btn btn-outline-secondary ms-2" (click)="loadMenus()">
                        <i class="fas fa-sync"></i>
                    </button>
                </div>
                }
            </div>

            <div cdkDropList class="menu-list" (cdkDropListDropped)="drop($event)">
                @for(item of menus(); track (item.uuid || item.id)){
                <div cdkDrag class="menu-item">
                    <div class="me-3 text-muted">
                        @if(item.parentUuid || item.parentId) {
                        <i class="fas fa-arrow-turn-up fa-rotate-90 me-2 text-muted small"></i>
                        }@else{
                        <i class="fas fa-grip-vertical"></i>
                        }
                    </div>

                    @if(menuKey(editingItem()) === menuKey(item)){
                    <div class="row g-2 align-items-center flex-grow-1">
                        <div class="col-12 col-md-4">
                            <input type="text" class="form-control form-control" [(ngModel)]="editingItem().name"
                                placeholder="Nombre">
                        </div>
                        <div class="col-12 col-md-3">
                            <ng-select [items]="icons" bindValue="value" bindLabel="label"
                                [(ngModel)]="editingItem().icon" [clearable]="false" placeholder="Icono">
                                <ng-template ng-option-tmp let-item="item">
                                    <i [class]="item.value" class="me-2 text-info fa-fw"></i> {{item.label}}
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    <i [class]="item.value" class="me-2 text-info"></i> {{item.label}}
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="col-12 col-md-3">
                            <ng-select [items]="routes" bindValue="value" bindLabel="label"
                                [(ngModel)]="editingItem().path" [addTag]="true" [clearable]="false" placeholder="Ruta">
                                <ng-template ng-option-tmp let-item="item">
                                    <span class="small text-muted me-2">{{item.value}}</span> {{item.label}}
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="col-12 col-md-2 d-flex">
                            <button class="btn btn-xs btn-success me-1 flex-fill" (click)="updateItem()"><i
                                    class="fas fa-check"></i></button>
                            <button class="btn btn-xs btn-danger flex-fill" (click)="cancelEdit()"><i
                                    class="fas fa-times"></i></button>
                        </div>
                    </div>
                    }@else {
                    <div class="me-3">
                        @if(!item.parentUuid && !item.parentId) {
                        <i [class]="item.icon || 'fas fa-link'" class="fa-fw text-info"></i>
                        }
                    </div>

                    <div class="flex-grow-1">

                        <span class="fw-bold">{{ item.name }}</span>
                        <div class="text-muted small">{{ item.path }}</div>
                    </div>

                    <div class="actions">
                        @if(item.parentUuid || item.parentId) {
                        <button class="btn btn-xs btn-link text-muted" (click)="outdent(item)" title="Hacer raíz">
                            <i class="fas fa-caret-left"></i>
                        </button>
                        } @else {
                        <button class="btn btn-xs btn-link text-muted" (click)="indent(item)" title="Hacer hijo">
                            <i class="fas fa-caret-right"></i>
                        </button>
                        }

                        <button class="btn btn-xs btn-link text-primary ms-2" (click)="editItem(item)">
                            <i class="fas fa-edit"></i>
                        </button>
                        <button class="btn btn-xs btn-link text-danger ms-1" (click)="deleteItem(item)">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                    }
                </div>
                }

                @if(menus().length === 0){
                <div class="text-center p-5 text-muted border border-dashed rounded">
                    <i class="fas fa-list fa-3x mb-3 opacity-25"></i>
                    <p>No se encontraron menús configurados.</p>
                </div>
                }
            </div>
        </div>
    </div>
</div>